<template>
  <div>
    <Info />
  </div>
</template>

<script>
import Info from "./info.vue";
export default {
  components: {
    Info,
  },
};
</script>
